const footerNavGroups = [
  {
    title: '追剧导航',
    links: [
      { label: '精选专题', href: '#carousel' },
      { label: '热门剧集', href: '#cards' },
      { label: '热播榜单', href: '#ranking' },
      { label: '剧集索引', href: '#index' },
    ],
  },
  {
    title: '平台信息',
    links: [
      { label: '追剧优势', href: '#features' },
      { label: '精彩看点', href: '#media' },
      { label: '更新动态', href: '#updates' },
      { label: '常见问题', href: '#faq' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '关于蓝莓影院', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '移动追剧', href: '#app' },
      { label: '热门话题', href: '#topics' },
    ],
  },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <span className="font-heading text-2xl font-bold text-white block mb-3">蓝莓影院</span>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              海量电视剧全集免费在线观看，热播剧大全不缓冲流畅播放，最新电视剧每日更新，经典老剧全集随时重温。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => { e.preventDefault(); handleNav('#hero'); }} className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-home-line text-background-100 text-sm"></i>
              </a>
              <a href="#contact" onClick={(e) => { e.preventDefault(); handleNav('#contact'); }} className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-mail-line text-background-100 text-sm"></i>
              </a>
              <a href="#faq" onClick={(e) => { e.preventDefault(); handleNav('#faq'); }} className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors">
                <i className="ri-question-line text-background-100 text-sm"></i>
              </a>
            </div>
          </div>

          {footerNavGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base text-white mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                      className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 pt-8 mb-8">
          <div className="text-center">
            <h4 className="font-heading text-base text-white mb-4">合作伙伴</h4>
            <div className="flex flex-wrap items-center justify-center gap-6">
              <span className="text-sm text-background-500">诚挚招募优质合作伙伴</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 蓝莓影院网 - 电视剧全集免费在线观看平台。本站所有内容仅供交流学习。
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" onClick={(e) => { e.preventDefault(); handleNav('#faq'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">常见问题</a>
            <a href="#about" onClick={(e) => { e.preventDefault(); handleNav('#about'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" onClick={(e) => { e.preventDefault(); handleNav('#contact'); }} className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}